import React from 'react';
import PropTypes from 'prop-types';
import s from './DataGrid.styles';

const CellWithDeletedStatus = ({ entity, field, deleted }) => {
  return (
    <s.CellWithDeletedStatus deleted={deleted(entity)}>
      {field(entity)}
    </s.CellWithDeletedStatus>
  );
};

CellWithDeletedStatus.propTypes = {
  entity: PropTypes.shape({}),
  field: PropTypes.func,
  deleted: PropTypes.func,
};

CellWithDeletedStatus.defaultProps = {
  field: (e) => e?.currentVersion?.name,
  deleted: (e) => !!e?.currentVersion?.deletedAt || !!e?.deletedAt,
};

export default React.memo(CellWithDeletedStatus);
